import { render, staticRenderFns } from "./completionSettlementDetail.vue?vue&type=template&id=21f9e87a&scoped=true&"
import script from "./completionSettlementDetail.vue?vue&type=script&lang=js&"
export * from "./completionSettlementDetail.vue?vue&type=script&lang=js&"
import style0 from "./completionSettlementDetail.vue?vue&type=style&index=0&id=21f9e87a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f9e87a",
  null
  
)

export default component.exports